<template>
  <donut-errors-base :code-chars="['422']" subtitle="We couldn't save that.">
    <div class="t-lg m-tx1">Something didn't look right.</div>
  </donut-errors-base>
</template>
